import { HeurekaElementFactory } from "../util/HeurekaElementFactory";

const ID_SCORES_FILTERS_BY_QUERY = "heureka_initial_scores";

export class FilterScores {
  private static readonly factory = HeurekaElementFactory.byId(ID_SCORES_FILTERS_BY_QUERY, FilterScores);

  private static highScoreFilterIds: string[] = [];

  /*               */
  constructor(private readonly elem: HTMLElement) {}

  /*                  */

  static template(rootElement?: ParentNode | null) {
    return FilterScores.factory.pick(undefined, rootElement);
  }

  /*               */

  static prepareAll(fragment: DocumentFragment, initialLoad = false) {
    if (initialLoad) {
      FilterScores.highScoreFilterIds = FilterScores.template(fragment)?.highScoreFilterIds || [];
    }
  }

  /*                       */

  private get highScoreFilterIds(): string[] {
    const highScoreFilterIds = this.elem.dataset.highScoreFilterIds;
    return highScoreFilterIds ? highScoreFilterIds.split(",") : [];
  }

  static hasLowScore(filterId: string): boolean {
    return !FilterScores.highScoreFilterIds.includes(filterId);
  }
}
